export const slider = {
  styleOverrides: {
    thumb: {
      '&:hover': {
        boxShadow: 'none'
      }
    }
  }
};
